import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors, calculateSpacing } from '@vds-core/theme';
import { withVDSManager } from '@vds-core/utilities';
var propTypes = {
  /**
   * Table requires TableHead or TableBody components as children.
   */
  children: PropTypes.node.isRequired,

  /**
   * @deprecated
   */
  className: PropTypes.string,

  /**
   * Boolean that adds padding to the left of the cell.
   */
  indentedCells: PropTypes.bool,

  /**
   * @deprecated topLine
   */
  tableBar: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'none']),

  /**
   * Define the type of top line for table. If none is passed then the top bar won't be visible.
   */
  topLine: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'heavy', 'light', 'xLight', 'none']),

  /**
   * @ignore
   * Object containing colors
   */
  colorConfig: PropTypes.object,

  /**
   * @ignore
   */
  tabIndex: PropTypes.number,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string,

  /**
   * Boolean used to invert table color
   */
  inverted: PropTypes.bool
};
var defaultProps = {
  className: undefined,
  indentedCells: false,
  //added after renaming
  topLine: 'heavy',
  colorConfig: colors,
  inverted: false
};
var StyledTable = /*#__PURE__*/styled.table.withConfig({
  displayName: "StyledTable",
  componentId: "sc-cgmk3m-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-collapse: collapse;\n  border-spacing: 0;\n  text-align: left;\n  width: 100%;\n  font-size: ", ";\n  margin-bottom: ", ";\n  padding-top: ", ";\n  ", ";\n  ", ";\n  border-top: ", "\n    solid\n    ", ";\n  &:focus {\n    outline: none;\n  }\n"])), calculateRem(14), calculateSpacing('8X', 'rem'), calculateRem(18), function (_ref) {
  var indentedCells = _ref.indentedCells;
  return indentedCells && "\n      td, th {\n        padding-left: ".concat(calculateRem(21), " !important;\n      }\n\n    ");
}, function (_ref2) {
  var inverted = _ref2.inverted,
      colorConfig = _ref2.colorConfig;
  return inverted && "\n      td, th {\n        background-color: ".concat(colorConfig.black, " !important;\n        color: ").concat(colorConfig.white, ";\n      }\n      tr{\n        border-bottom: ").concat(calculateRem(1), " solid\n          ").concat(colorConfig.white, ";\n        :last-child {\n          border: none;\n        }\n      }\n    ");
}, function (_ref3) {
  var tableBar = _ref3.tableBar,
      topLine = _ref3.topLine;

  if (tableBar === 'none' || topLine === 'none') {
    return 0;
  }

  return tableBar === 'primary' || topLine === 'primary' || topLine === 'heavy' ? calculateRem(4) : calculateRem(1);
}, function (_ref4) {
  var tableBar = _ref4.tableBar,
      topLine = _ref4.topLine,
      colorConfig = _ref4.colorConfig,
      inverted = _ref4.inverted;
  return inverted ? colorConfig.white : tableBar === 'tertiary' || topLine === 'tertiary' || topLine === 'xLight' ? colorConfig.coolGray3 : colorConfig.black;
});

var Table = function Table(props) {
  var ariaLabel = props.ariaLabel,
      children = props.children,
      indentedCells = props.indentedCells,
      colorConfig = props.colorConfig,
      tabIndex = props.tabIndex,
      id = props.id,
      inverted = props.inverted;
  return /*#__PURE__*/React.createElement(StyledTable, _extends({
    id: id,
    "aria-label": ariaLabel ? ariaLabel : 'Table',
    indentedCells: indentedCells,
    colorConfig: colorConfig,
    tabIndex: tabIndex,
    inverted: inverted
  }, props), children);
};

Table.defaultProps = defaultProps;
Table.propTypes = propTypes;
export default withVDSManager(Table);